module.exports = __webpack_public_path__ + "front/img/bg03.c2666654.png";